import React from 'react';
import { getMediaUrl, MediaConfig } from '@musedrops/shared';
import { AudioFileField } from '../../../shared/components/forms/AudioFileField';

interface IntroMusicSectionProps {
  showSlug: string;
  showId?: string;
  introMusicUpdatedAt?: string | null;
  onIntroMusicDeleted?: () => void;
  // eslint-disable-next-line no-unused-vars
  onIntroMusicUpdatedAtChanged?: (timestamp: string) => void;
}

/**
 * Intro Music Section Component
 *
 * Wrapper around AudioFileField for show intro music.
 * Uses conventional filename from MediaConfig.
 */
export const IntroMusicSection: React.FC<IntroMusicSectionProps> = ({
  showSlug,
  showId,
  introMusicUpdatedAt,
  onIntroMusicDeleted,
  onIntroMusicUpdatedAtChanged,
}) => {
  const introMusicFile = MediaConfig.show.introMusic; // 'intro.mp3'

  // Construct audio URL with timestamp for cache-busting
  const audioUrl = React.useMemo(() => {
    if (showSlug && introMusicUpdatedAt) {
      return `${getMediaUrl('shows', showSlug, introMusicFile)}?t=${new Date(introMusicUpdatedAt).getTime()}`;
    }
    if (showSlug) {
      return getMediaUrl('shows', showSlug, introMusicFile);
    }
    return undefined;
  }, [showSlug, introMusicUpdatedAt, introMusicFile]);

  return (
    <AudioFileField
      label="Intro Music"
      value={introMusicUpdatedAt ? introMusicFile : null} // Show filename if file exists (timestamp present)
      onUpload={() => {
        // No-op handler - just enables upload button. Timestamp update handled by onTimestampChanged.
      }}
      onDelete={onIntroMusicDeleted}
      onTimestampChanged={onIntroMusicUpdatedAtChanged}
      audioUrl={audioUrl}
      storageFolder="shows"
      slug={showSlug}
      entityId={showId}
      tableName="shows"
      fileType="introMusic"
      accept="audio/*"
      uploadTitle="Upload Intro Music"
    />
  );
};
